import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { withLDProvider } from 'launchdarkly-react-client-sdk';
import FontAwesomeCollection from '@bit/fabfitfun.shared.global.font-awesome-collection';

import Reactivate from './pages/Reactivate';
import Upgrade from './pages/Upgrade';
import TrialUpgradeThanks from './pages/TrialUpgradeThanks';
import UpgradeThanks from './pages/UpgradeThanks';
import TrialUpgrade from './pages/TrialUpgrade';
import EmailPreferences from './pages/EmailPreferences';
import NotFoundError from './pages/NotFoundError';
import './App.css';

function App() {
  return (
    <>
      <FontAwesomeCollection />
      <Router>
        <Switch>
          <Route exact path="/reactivate-my-membership" component={Reactivate} />
          <Route exact path="/upgrade-confirmation" component={Upgrade} />
          <Route exact path="/activate-membership" component={TrialUpgrade} />
          <Route exact path="/trial-upgrade-thanks" component={TrialUpgradeThanks} />
          <Route exact path="/upgrade-thanks" component={UpgradeThanks} />
          <Route exact path="/manage-email-preferences" component={EmailPreferences} />
          <Route exact path="/my-account-v3/reactivate-my-membership" component={Reactivate} />
          <Route exact path="/my-account-v3/upgrade-confirmation" component={Upgrade} />
          <Route exact path="/my-account-v3/activate-membership" component={TrialUpgrade} />
          <Route exact path="/my-account-v3/manage-email-preferences" component={EmailPreferences} />
          <Route exact path="/my-account-v3/trial-upgrade-thanks" component={TrialUpgradeThanks} />
          <Route exact path="/my-account-v3/upgrade-thanks" component={UpgradeThanks} />
          <Route component={NotFoundError} />
        </Switch>
      </Router>
    </>
  );
}

export default withLDProvider({
  clientSideID: process.env.REACT_APP_LD_CLIENT_ID,
  options: { bootstrap: 'localStorage' },
  user: {
    key: 'anonymous',
  },
})(App);
